export enum ResidencyStatus {
  PermanentResident = 1,
  CurrentlyInAustraliaOnVisa = 2,
}
